import loaderAnimation from '../assets/loading.gif';
import React from 'react';

const Loader = () => {
  return (
    <div className="flex flex-col justify-center items-center h-screen bg-purple-400">
      <img 
        src={loaderAnimation} 
        alt="loader" 
        className="w-24 h-24 md:w-32 md:h-32 lg:w-40 lg:h-40 rounded-full" 
      />
      <h1 className="text-white mt-4 text-xl md:text-2xl lg:text-4xl font-bold text-center">
        Welcome In Powergenic....
      </h1>
    </div>
  );
};

export default Loader;
